import { render } from "./PickzenLogoIcon.vue?vue&type=template&id=6c6aba50"
import script from "./PickzenLogoIcon.vue?vue&type=script&lang=js"
export * from "./PickzenLogoIcon.vue?vue&type=script&lang=js"

import "./PickzenLogoIcon.vue?vue&type=style&index=0&id=6c6aba50&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__